import apiClient from './client';

export const accountApi = {
  /**
   * Get account information
   */
  getAccount: async () => {
    const response = await apiClient.get('/api/account');
    return response.data;
  },

  /**
   * Get all open positions
   */
  getPositions: async () => {
    const response = await apiClient.get('/api/account/positions');
    return response.data;
  },

  /**
   * Close a single position by symbol
   */
  closePosition: async (symbol) => {
    const response = await apiClient.delete(`/api/account/positions/${symbol}`);
    return response.data;
  },

  /**
   * Close all positions (liquidate)
   */
  closeAllPositions: async () => {
    const response = await apiClient.delete('/api/account/positions');
    return response.data;
  },

  /**
   * Get account activities
   * @param {string} activityType - Activity type (optional)
   * @param {Object} options - Query options (date, until, after, direction, page_size, page_token)
   */
  getActivities: async (activityType = null, options = {}) => {
    const params = new URLSearchParams();
    // Don't add activity_type to query params if it's in the path
    if (options.date) params.append('date', options.date);
    if (options.until) params.append('until', options.until);
    if (options.after) params.append('after', options.after);
    if (options.direction) params.append('direction', options.direction);
    if (options.page_size) params.append('page_size', options.page_size.toString());
    if (options.page_token) params.append('page_token', options.page_token);
    
    // Use path parameter for activity type if provided
    const url = activityType 
      ? `/api/account/activities/${activityType}${params.toString() ? '?' + params.toString() : ''}`
      : `/api/account/activities${params.toString() ? '?' + params.toString() : ''}`;
    
    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * Get combined portfolio value (Alpaca + custom portfolios)
   */
  getCombinedPortfolio: async () => {
    const response = await apiClient.get('/api/account/combined-portfolio');
    return response.data;
  },

  /**
   * Get latest vs previous balance summary (equity/portfolio_value deltas)
   */
  getBalanceSummary: async () => {
    const response = await apiClient.get('/api/account/balances/summary');
    return response.data;
  },

  /**
   * Portfolio equity / P/L history
   * @param {{ period?: string, timeframe?: string, start?: string, end?: string }} options
   */
  getPortfolioHistory: async (options = {}) => {
    const params = new URLSearchParams();
    if (options.period) params.set('period', options.period);
    if (options.timeframe) params.set('timeframe', options.timeframe);
    if (options.start) params.set('start', options.start);
    if (options.end) params.set('end', options.end);
    if (options.extendedHours) params.set('extended_hours', 'true');
    const qs = params.toString();
    const response = await apiClient.get(
      `/api/account/portfolio-history${qs ? `?${qs}` : ''}`
    );
    return response.data;
  },

  /**
   * Period P/L for a preset (today | ytd | 1w | 1m | 3m | 1y | all | custom)
   * @param {{ preset?: string, start?: string, end?: string }} options
   */
  getPeriodPl: async (options = {}) => {
    const params = new URLSearchParams();
    if (options.preset) params.set('preset', options.preset);
    if (options.start) params.set('start', options.start);
    if (options.end) params.set('end', options.end);
    const qs = params.toString();
    const response = await apiClient.get(`/api/account/period-pl${qs ? `?${qs}` : ''}`);
    return response.data;
  },
};

